// src/Pages/Brands.js — 取り扱いメーカーの一覧
import { useEffect } from "react";
import { useBrandMap, useProducts } from "../api/products";
import { Container, Group, Row, Button } from "../Components/ui";

export default function Brands() {
  const { brandMap, ready } = useBrandMap();
  const { products, ready: productsReady } = useProducts();

  useEffect(() => {
    document.title = "取り扱い商品｜CAMARAGO";
  }, []);

  const entries = Object.entries(brandMap);
  const countFor = (name) => products.filter((p) => p.makerName === name).length;

  return (
    <div className="bg-fill-2 pb-20">
      <Container narrow className="pt-10 md:pt-16">
        <h1 className="px-1 text-[32px] font-bold leading-tight tracking-tight md:text-[44px]">取り扱い商品</h1>
        <p className="mt-2 px-1 text-[15px] text-ink-2 md:text-[17px]">
          メーカーを選ぶと、掲載している防犯カメラを一覧で確認できます。
        </p>

        <div className="mt-8">
          {!ready ? (
            <div className="py-10 text-center text-[15px] text-ink-2" role="status">読み込み中です…</div>
          ) : (
            <Group>
              {entries.map(([slug, name]) => (
                <Row key={slug} to={`/brands/${slug}`} accessory="chevron" detail={productsReady ? `${countFor(name)}機種` : null}>
                  <span className="text-[17px]">{name}</span>
                </Row>
              ))}
            </Group>
          )}
        </div>

        <div className="mt-10 rounded-[18px] bg-white p-6 text-center">
          <p className="text-[17px] font-semibold">どれを選べばいいか迷ったら</p>
          <p className="mt-1 text-[15px] text-ink-2">質問に答えるだけで、条件に合う機種をしぼり込めます。</p>
          <Button to="/wizard" className="mt-5">
            無料で診断する
          </Button>
        </div>
      </Container>
    </div>
  );
}
